<template>
  <BgImageLayout title="Dashboard">
    <Workflow />

    <Grid gtc="2fr 1fr" gap="var(--r-space-md) var(--r-space-sp)" class="q-mt-md">
      <Grid gap="var(--r-space-md)" align-content="start">
        <FinancialOverview />
        <ToDoList />
      </Grid>

      <Grid gap="var(--r-space-md)" align-content="start">
        <RenewalStatus />
        <TotalSpend />
        <Reminders />
      </Grid>
    </Grid>
  </BgImageLayout>
</template>

<script>
// Components
import Workflow from './components/Workflow'
import FinancialOverview from './components/FinancialOverview'
import ToDoList from './components/ToDoList'
import RenewalStatus from './components/renewal-status/RenewalStatus'
import TotalSpend from './components/total-spend/TotalSpend'
import Reminders from './components/Reminders'

export default {
  components: {
    Workflow,
    FinancialOverview,
    ToDoList,
    RenewalStatus,
    TotalSpend,
    Reminders
  }
}
</script>
